import AnaltyicsHeader from './AnalyticsHeader';
import AvgCompletionGraph from './allPlatformAnalytics/AvgCompletionGraph';
import ActiveUsersList from './desktopAnalytics/ActiveUsersList';
import UniqueUserCount from './desktopAnalytics/UniqueUsersCount';

import '../../styles/analytics.css';


const AnalyticsHome = () => {


    return (
        <div className="wrapper">
            <AnaltyicsHeader />
            <div className='main-panel main-panel-analytics'>
                <div className='container'>
                    <div className='page-inner'>
                        <h4 className='page-title'>Desktop</h4>
                        <div className='row'>
                            <div className='col-md-6'>
                                <UniqueUserCount />
                            </div>
                            <div className='col-md-6'>
                                <ActiveUsersList />
                            </div>
                        </div>
                        <h4 className='page-title'>All Platforms</h4>
                        <div className='row'>
                            <div className='col-md-6'>
                                <AvgCompletionGraph />
                            </div>
                            <div className='col-md-6'>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default AnalyticsHome;

